module.exports = __webpack_public_path__ + "static/media/template4.a36738a7.png";